import { useEffect, useState } from 'react'
import { apiJson } from '../../lib/api'
import { BilingualField, ui } from './shared'

interface Row { key: string; value_it: string | null; value_en: string | null }

const keys = [
  { key: 'meta_title',       label: 'Meta title' },
  { key: 'meta_description', label: 'Meta description' },
]

export function SiteEditor() {
  const [rows, setRows] = useState<Record<string, { it: string; en: string }>>({})
  const [loading, setLoading] = useState(true)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [msg, setMsg] = useState<string | null>(null)

  useEffect(() => {
    apiJson<{ site_config: Row[] }>('/api/admin/site_config').then((r) => {
      const m: Record<string, { it: string; en: string }> = {}
      for (const k of keys) m[k.key] = { it: '', en: '' }
      for (const row of r.site_config) {
        m[row.key] = { it: row.value_it ?? '', en: row.value_en ?? '' }
      }
      setRows(m)
    })
      .catch((e) => setError(String(e)))
      .finally(() => setLoading(false))
  }, [])

  async function save() {
    setBusy(true); setError(null); setMsg(null)
    try {
      for (const k of keys) {
        await apiJson(`/api/admin/site_config/${k.key}`, {
          method: 'PUT',
          body: JSON.stringify({ value_it: rows[k.key]?.it ?? '', value_en: rows[k.key]?.en ?? '' }),
        })
      }
      setMsg('Salvato.')
    } catch (err) { setError(String(err)) }
    finally { setBusy(false) }
  }

  if (loading) return <div style={{ color: 'var(--fg-muted)' }}>Carico…</div>

  return (
    <div>
      <h1 style={ui.sectionTitle}>SEO / Meta</h1>
      <div style={{ ...ui.card, display: 'flex', flexDirection: 'column', gap: 18 }}>
        {keys.map((k) => (
          <BilingualField key={k.key} label={k.label}
            valueIt={rows[k.key]?.it ?? ''} valueEn={rows[k.key]?.en ?? ''}
            onItChange={(v) => setRows({ ...rows, [k.key]: { ...rows[k.key], it: v } })}
            onEnChange={(v) => setRows({ ...rows, [k.key]: { ...rows[k.key], en: v } })}
            multiline={k.key.includes('description')} />
        ))}

        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" style={ui.btn} disabled={busy} onClick={save}>{busy ? '…' : 'Salva'}</button>
          {msg && <span style={{ alignSelf: 'center', color: 'var(--fg-soft)', fontSize: 13 }}>{msg}</span>}
          {error && <span style={{ alignSelf: 'center', color: '#a33' }}>{error}</span>}
        </div>
      </div>
    </div>
  )
}
